document.querySelectorAll(".scroll-visibility").forEach(function(el) {

});
